import React from 'react'
import "../../../styles/JourneyJunkies.css";

function JourneyJunkies(props) {
  return (
    <div id="Journey_Junkies">
	<svg class="Jrny_Jnks_Rectangle_682_cb">
		<linearGradient id="Jrny_Jnks_Rectangle_682_cb" spreadMethod="pad" x1="0.5" x2="0.5" y1="0" y2="1">
			<stop offset="0" stop-color="#d5ffd9" stop-opacity="1"></stop>
			<stop offset="1" stop-color="#fff" stop-opacity="1"></stop>
		</linearGradient>
		<rect id="Jrny_Jnks_Rectangle_682_cb" rx="0" ry="0" x="0" y="0" width="1366" height="786">
		</rect>
	</svg>
	<svg class="Jrny_Jnks_path_3" viewBox="0 0 477.724 462.343">
		<path id="Jrny_Jnks_path_3" d="M 419.6527709960938 139.2779235839844 C 419.6527709960938 139.2779235839844 320.0023193359375 -98.99415588378906 148.664306640625 47.76374816894531 C -22.673828125 194.5215759277344 -37.13275146484375 283.44384765625 60.46490478515625 369.474365234375 C 158.0625 455.5047912597656 327.2317504882812 462.0113830566406 327.2317504882812 462.0113830566406 C 327.2317504882812 462.0113830566406 528.9335327148438 480.0849304199219 465.3143920898438 249.4654541015625 C 457.0326538085938 219.4443054199219 419.6527709960938 139.2779235839844 419.6527709960938 139.2779235839844 Z">
		</path>
	</svg>
	<svg class="Jrny_Jnks_path_2" viewBox="0 0 477.724 462.343">
		<path id="Jrny_Jnks_path_2" d="M 419.6527709960938 139.2779235839844 C 419.6527709960938 139.2779235839844 320.0023193359375 -98.99415588378906 148.664306640625 47.76374816894531 C -22.673828125 194.5215759277344 -37.13275146484375 283.44384765625 60.46490478515625 369.474365234375 C 158.0625 455.5047912597656 327.2317504882812 462.0113830566406 327.2317504882812 462.0113830566406 C 327.2317504882812 462.0113830566406 528.9335327148438 480.0849304199219 465.3143920898438 249.4654541015625 C 457.0326538085938 219.4443054199219 419.6527709960938 139.2779235839844 419.6527709960938 139.2779235839844 Z">
		</path>
	</svg>
	<img id="Jrny_Jnks_path_1" src="./Themes/JourneyJunkies/path_1.png"  srcset="./Themes/JourneyJunkies/path_1.png 1x" />
		
	<div id="Jrny_Jnks_explore_Unwind_Discover">
		<span>Explore<br/>Unwind<br/>Discover</span>
	</div>
	<div id="Jrny_Jnks_Scroll_Group_19">
		<div id="Jrny_Jnks_Lorem_ipsum_dolor_sit_amet_con">
			<span>{props.data.introduction}</span>
		</div>
	</div>
	<svg class="Jrny_Jnks_Ellipse_1">
		<ellipse id="Jrny_Jnks_Ellipse_1" rx="11" ry="10.5" cx="11" cy="10.5">
		</ellipse>
	</svg>
	<svg class="Jrny_Jnks_Line_1" viewBox="0 0 4 172.795">
		<path id="Jrny_Jnks_Line_1" d="M 0 0 L 0 172.7948913574219">
		</path>
	</svg>
	<img id="Jrny_Jnks_joaquin-3VK6Urf2vE8-unsplash" src="./Themes/JourneyJunkies/joaquin-3VK6Urf2vE8-unsplash.png"  srcset="./Themes/JourneyJunkies/joaquin-3VK6Urf2vE8-unsplash.png 1x" />
		
	<img id="Jrny_Jnks_ammie-ngo-vcu-OZBxxRk-unsplash" src="./Themes/JourneyJunkies/ammie-ngo-vcu-OZBxxRk-unsplash.png"  srcset="./Themes/JourneyJunkies/ammie-ngo-vcu-OZBxxRk-unsplash.png 1x" />
		
	<img id="Jrny_Jnks_daniel-burka-facU72FcKBI-unspl" src="./Themes/JourneyJunkies/daniel-burka-facU72FcKBI-unspl.png"  srcset="./Themes/JourneyJunkies/daniel-burka-facU72FcKBI-unspl.png 1x" />
		
	<div id="Jrny_Jnks_Group_4">
		<svg class="Jrny_Jnks_Ellipse_2">
			<ellipse id="Jrny_Jnks_Ellipse_2" rx="19" ry="19" cx="19" cy="19">
			</ellipse>
		</svg>
		<div id="Jrny_Jnks_Icon_feather-arrow-down-right">
			<svg class="Jrny_Jnks_Path_2_cq" viewBox="0 0 5 5">
				<path id="Jrny_Jnks_Path_2_cq" d="M 5 5.900714419577839e-15 L 5 5 L 5.900714419577839e-15 5">
				</path>
			</svg>
		</div>
	</div>
	<div id="Jrny_Jnks_Group_5">
		<svg class="Jrny_Jnks_Ellipse_3">
			<ellipse id="Jrny_Jnks_Ellipse_3" rx="19" ry="19" cx="19" cy="19">
			</ellipse>
		</svg>
		<div id="Jrny_Jnks_Group_1">
			<svg class="Jrny_Jnks_Path_1_cu" viewBox="0 0 11.645 11.645">
				<path id="Jrny_Jnks_Path_1_cu" d="M 0 0 L 11.64523315429688 11.64523315429688">
				</path>
			</svg>
			<svg class="Jrny_Jnks_Path_2_cv" viewBox="0 0 7.793 7.793">
				<path id="Jrny_Jnks_Path_2_cv" d="M 7.792517185211182 -6.384611213333538e-15 L 7.792517185211182 7.792517185211182 L -6.384611213333538e-15 7.792517185211182">
				</path>
			</svg>
		</div>
	</div>
	<div id="Jrny_Jnks_Group_14866">
		<svg class="Jrny_Jnks_Rectangle_2_c">
			<rect id="Jrny_Jnks_Rectangle_2_c" rx="0" ry="0" x="0" y="0" width="129" height="39">
			</rect>
		</svg>
		<div id="Jrny_Jnks_Check_Out">
			<span>Explore!!</span>
		</div>
	</div>
	<div id="Jrny_Jnks_Group_3">
		<svg class="Jrny_Jnks_Rectangle_3">
			<rect id="Jrny_Jnks_Rectangle_3" rx="19" ry="19" x="0" y="0" width="128" height="38">
			</rect>
		</svg>
		<div id="Jrny_Jnks_See_all_photos">
			<span>See all photos</span>
		</div>
	</div>
    
	<svg class="Jrny_Jnks_Ellipse_4">
		<ellipse id="Jrny_Jnks_Ellipse_4" rx="19" ry="19" cx="19" cy="19">
		</ellipse>
	</svg>
	<svg class="Jrny_Jnks_Ellipse_5">
		<ellipse id="Jrny_Jnks_Ellipse_5" rx="19" ry="19" cx="19" cy="19">
		</ellipse>
	</svg>
        {props.data.linkedInUrl?	
	<svg class="Jrny_Jnks_Icon_awesome-facebook-f" viewBox="1.609 0 10.87 20.295">
		 <path id="Jrny_Jnks_Icon_awesome-facebook-f" d="M -5.594671249389648 3.814697265625e-06 C -8.203055381774902 3.814697265625e-06 -9.837490081787109 1.412798166275024 -10.13955497741699 2.402577638626099 L -10.13955497741699 0.1386871188879013 L -15.2549991607666 0.1386871188879013 C -15.18850803375244 1.3406081199646 -15.2549991607666 14.56553649902344 -15.2549991607666 14.56553649902344 L -10.13955497741699 14.56553649902344 L -10.13955497741699 6.758750915527344 C -10.13955497741699 6.324968814849854 -10.16045379638672 5.891188621520996 -10.02873420715332 5.579627513885498 C -9.676643371582031 4.71206521987915 -8.921167373657227 3.811574220657349 -7.562833309173584 3.811574220657349 C -5.78718090057373 3.811574220657349 -4.979146957397461 5.145845413208008 -4.979146957397461 7.100076198577881 L -4.979146957397461 14.56553649902344 L 0.1837937831878662 14.56553649902344 L 0.1837937831878662 6.543442726135254 C 0.1837937831878662 2.075184345245361 -2.358731746673584 3.814697265625e-06 -5.594671249389648 3.814697265625e-06">
					</path>
	</svg>:""}
    
    {props.data.instagramUrl?	
	<svg class="Jrny_Jnks_Icon_metro-twitter" viewBox="2.571 4.817 19.526 15.868">
		 <a href={props.data.instagramUrl} target="_blank">
			<img id="Jrny_Jnks_Icon_metro" src="./Themes/JourneyJunkies/instagramshadow_space_website_.png"  srcset="./Themes/JourneyJunkies/instagramshadow_space_website_.png 1x" />
				
			</a>
	</svg>:""}
	<svg class="Jrny_Jnks_Rectangle_5">
		<rect id="Jrny_Jnks_Rectangle_5" rx="19" ry="19" x="0" y="0" width="38" height="38">
		</rect>
	</svg>
		{props.data.whatsAppNumber?<>
    <a href={"https://api.whatsapp.com/send?phone="+props.data.whatsAppNumber.substring(props.data.whatsAppNumber.length-10)} target="_blank">
	<svg class="Jrny_Jnks_Icon_simple-whatsapp" viewBox="0 0 22.786 22.786">
		<path id="Jrny_Jnks_Icon_simple-whatsapp" d="M 16.61299514770508 13.65459442138672 C 16.32721900939941 13.51218128204346 14.93536567687988 12.83144474029541 14.67617321014404 12.73745250701904 C 14.4169807434082 12.64156055450439 14.22709655761719 12.59503936767578 14.03721141815186 12.87986660003662 C 13.85017585754395 13.15994548797607 13.30520725250244 13.79510879516602 13.14095687866211 13.98309516906738 C 12.9748067855835 14.16823196411133 12.80960750579834 14.18247413635254 12.52762985229492 14.05430126190186 C 12.24280261993408 13.91188812255859 11.3285083770752 13.61281967163086 10.24616718292236 12.64441013336182 C 9.403080940246582 11.88961982727051 8.837224960327148 10.9639310836792 8.670125961303711 10.67910575866699 C 8.504926681518555 10.39427852630615 8.652087211608887 10.237624168396 8.793551445007324 10.09521102905273 C 8.922673225402832 9.967038154602051 9.079327583312988 9.767660140991211 9.22174072265625 9.598662376403809 C 9.360356330871582 9.426817893981934 9.405928611755371 9.312886238098145 9.503719329833984 9.127748489379883 C 9.598661422729492 8.928370475769043 9.550241470336914 8.77171516418457 9.479983329772949 8.630250930786133 C 9.408777236938477 8.487837791442871 8.841971397399902 7.092186450958252 8.604616165161133 6.535824775695801 C 8.376754760742188 5.981361865997314 8.142247200012207 6.051619052886963 7.966603755950928 6.051619052886963 C 7.803302764892578 6.037377834320068 7.614367961883545 6.037377834320068 7.424483776092529 6.037377834320068 C 7.234599113464355 6.037377834320068 6.927935600280762 6.107635021209717 6.667793750762939 6.378220558166504 C 6.4086012840271 6.663046836853027 5.675647258758545 7.346631050109863 5.675647258758545 8.728041648864746 C 5.675647258758545 10.10945224761963 6.691528797149658 11.4481372833252 6.832993030548096 11.64751529693604 C 6.974457263946533 11.8326530456543 8.831527709960938 14.68092060089111 11.67504787445068 15.90567588806152 C 12.35293579101562 16.19050407409668 12.88081550598145 16.36139869689941 13.2928638458252 16.50286293029785 C 13.97075080871582 16.71838188171387 14.58882617950439 16.6879997253418 15.07777786254883 16.61774253845215 C 15.62274646759033 16.53134536743164 16.75540733337402 15.93320846557617 16.99181365966797 15.26386642456055 C 17.23391723632812 14.59452342987061 17.23391723632812 14.03911209106445 17.16271018981934 13.91093921661377 C 17.09245300292969 13.7827672958374 16.9063663482666 13.71156024932861 16.62154006958008 13.58338832855225 M 11.45098400115967 20.64994049072266 L 11.43579387664795 20.64994049072266 C 9.755315780639648 20.64994049072266 8.090028762817383 20.19421768188477 6.636462688446045 19.33973693847656 L 6.294670581817627 19.13656044006348 L 2.734336137771606 20.06224822998047 L 3.68850564956665 16.60160255432129 L 3.461593866348267 16.24556922912598 C 2.521665334701538 14.74927806854248 2.022269248962402 13.0260763168335 2.022269248962402 11.25160694122314 C 2.022269248962402 6.082000732421875 6.251946449279785 1.866564512252808 11.46142864227295 1.866564512252808 C 13.98119640350342 1.866564512252808 16.3462085723877 2.84921669960022 18.12732315063477 4.629383563995361 C 19.90749168395996 6.394360065460205 20.88919258117676 8.759372711181641 20.88919258117676 11.26584720611572 C 20.88539505004883 16.43450355529785 16.6547679901123 20.65088844299316 11.45668029785156 20.65088844299316 M 19.48215103149414 3.274558067321777 C 17.31746673583984 1.18203067779541 14.46919918060303 -3.500477703255456e-07 11.43579387664795 -3.500477703255456e-07 C 5.186695098876953 -3.500477703255456e-07 0.09873994439840317 5.06421947479248 0.09589167684316635 11.29148197174072 C 0.09589167684316635 13.28147220611572 0.617124617099762 15.22209072113037 1.610220551490784 16.93579864501953 L 0 22.78614044189453 L 6.014591217041016 21.21769332885742 C 7.672283172607422 22.11300086975098 9.536948204040527 22.58865928649902 11.43579387664795 22.59150886535645 L 11.44149017333984 22.59150886535645 C 17.69343757629395 22.59150886535645 22.78329086303711 17.525390625 22.78614044189453 11.29717922210693 C 22.78614044189453 8.281813621520996 21.60885620117188 5.443988800048828 19.46790885925293 3.311586380004883">
		</path>
	</svg></a></>:""}
	<img id="Jrny_Jnks_leaf" src="./Themes/JourneyJunkies/leaf.png"  srcset="./Themes/JourneyJunkies/leaf.png 1x" />
		
	<div id="Jrny_Jnks_Group_14870">
		<svg class="Jrny_Jnks_Rectangle_683">
			<rect id="Jrny_Jnks_Rectangle_683" rx="0" ry="0" x="0" y="0" width="728" height="340">
			</rect>
		</svg>
		<img id="Jrny_Jnks_pietro-de-grandi-T7K4aEPoGGk-u" src="./Themes/JourneyJunkies/pietro-de-grandi-T7K4aEPoGGk-u.png"  srcset="./Themes/JourneyJunkies/pietro-de-grandi-T7K4aEPoGGk-u.png 1x" />
			
		<div id="Jrny_Jnks_VISION">
			<span>VISION</span>
		</div>
		<div id="Jrny_Jnks_Lorem_ipsum_dolor_sit_amet_con_dj">
			<span>{props.data.vision}</span>
		</div>
	</div>
	<div id="Jrny_Jnks_Group_14869">
		<svg class="Jrny_Jnks_Rectangle_684">
			<rect id="Jrny_Jnks_Rectangle_684" rx="0" ry="0" x="0" y="0" width="748" height="349">
			</rect>
		</svg>
		<img id="Jrny_Jnks_jake-blucker-tMzCrBkM99Y-unspl_dq" src="./Themes/JourneyJunkies/jake-blucker-tMzCrBkM99Y-unspl_dq.png"  srcset="./Themes/JourneyJunkies/jake-blucker-tMzCrBkM99Y-unspl_dq.png 1x" />
			
		<div id="Jrny_Jnks_MISSION">
			<span>MISSION</span>
		</div>
		<div id="Jrny_Jnks_Lorem_ipsum_dolor_sit_amet_con_ds">
			<span>{props.data.mission}</span>
		</div>
		{/* <svg class="Jrny_Jnks_Rectangle_685">
			<rect id="Jrny_Jnks_Rectangle_685" rx="0" ry="0" x="0" y="0" width="748" height="349">
			</rect>
		</svg>
		<img id="Jrny_Jnks_jake-blucker-tMzCrBkM99Y-unspl_dq" src="./Themes/JourneyJunkies/jake-blucker-tMzCrBkM99Y-unspl_dq.png"  srcset="./Themes/JourneyJunkies/jake-blucker-tMzCrBkM99Y-unspl_dq.png 1x" />
			
		<div id="Jrny_Jnks_MISSION_dr">
			<span>MISSION</span>
		</div>
		<div id="Jrny_Jnks_Lorem_ipsum_dolor_sit_amet_con_ds">
			<span>{props.data.mission}</span>
		</div> */}

		<div id="Jrny_Jnks_Group_14871">
		<img id="Jrny_Jnks_taneli-lahtinen-2gJJrH4OnNk-un" src="./Themes/JourneyJunkies/taneli-lahtinen-2gJJrH4OnNk-un.png" srcset="./Themes/JourneyJunkies/taneli-lahtinen-2gJJrH4OnNk-un.png 1x" />
			
		<div id="Jrny_Jnks_Scroll_Group_23">
		{props.offeringsData.map((rec,idx)=>(
			<div id="Jrny_Jnks_Group_14872">
				<svg class="Jrny_Jnks_Rectangle_688">
					<rect id="Jrny_Jnks_Rectangle_688" rx="10" ry="10" x="0" y="0" width="250" height="350">
					</rect>
				</svg>
				<img id="Jrny_Jnks_dariusz-sankowski-3OiYMgDKJ6k-" src={rec.defaultOfferingsImageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+(rec.defaultOfferingsImageUrl.split('/')[5]):"./Themes/JourneyJunkies/dariusz-sankowski-3OiYMgDKJ6k-.png"} />
					
				<div id="Jrny_Jnks_Travel_One">
					<span>{rec.offeringTitle}</span>
				</div>
			</div>
			))}
		</div>
	</div>

	</div>
	<div id="Jrny_Jnks_Group_14868">
		<svg class="Jrny_Jnks_Rectangle_686">
			<rect id="Jrny_Jnks_Rectangle_686" rx="0" ry="0" x="0" y="0" width="748" height="350">
			</rect>
		</svg>
		<img id="Jrny_Jnks_tom-barrett-M0AWNxnLaMw-unspla" src="./Themes/JourneyJunkies/tom-barrett-M0AWNxnLaMw-unspla.png"  srcset="./Themes/JourneyJunkies/tom-barrett-M0AWNxnLaMw-unspla.png 1x" />
			
		<div id="Jrny_Jnks_PRINCIPLES">
			<span>PRINCIPLES</span>
		</div>
		<div id="Jrny_Jnks_Lorem_ipsum_dolor_sit_amet_con_dx">
			<span>{props.data.principles}</span>
		</div>
	</div>

	<div id="Jrny_Jnks_FIND_POPULAR_DESTINATION_">
		<span>FIND POPULAR </span><span style={{color:"rgba(255,52,52,1)"}}>DESTINATION</span><span> !!</span>
	</div>
	<svg class="Jrny_Jnks_Line_28" viewBox="0 0 1269 2">
		<path id="Jrny_Jnks_Line_28" d="M 0 0 L 1269 0">
		</path>
	</svg>
	<div id="Jrny_Jnks_socials_grp_shadow_space_websi">
    {props.data.linkedInUrl?
		<div title="LinkedIn" id="Jrny_Jnks_linked_in_grp_shadow_space_web">
			<svg class="Jrny_Jnks_med_shadow_space_website_7">
				<ellipse id="Jrny_Jnks_med_shadow_space_website_7" rx="24" ry="24" cx="24" cy="24">
				</ellipse>
			</svg>
			<div id="Jrny_Jnks_linked_in_shadow_space_website">
				<a href={props.data.linkedInUrl} target="_blank">
				<svg class="Jrny_Jnks_n_website_7_layout_" viewBox="-15.255 0 15.439 14.566">
					<path id="Jrny_Jnks_n_website_7_layout_" d="M -5.594671249389648 3.814697265625e-06 C -8.203055381774902 3.814697265625e-06 -9.837490081787109 1.412798166275024 -10.13955497741699 2.402577638626099 L -10.13955497741699 0.1386871188879013 L -15.2549991607666 0.1386871188879013 C -15.18850803375244 1.3406081199646 -15.2549991607666 14.56553649902344 -15.2549991607666 14.56553649902344 L -10.13955497741699 14.56553649902344 L -10.13955497741699 6.758750915527344 C -10.13955497741699 6.324968814849854 -10.16045379638672 5.891188621520996 -10.02873420715332 5.579627513885498 C -9.676643371582031 4.71206521987915 -8.921167373657227 3.811574220657349 -7.562833309173584 3.811574220657349 C -5.78718090057373 3.811574220657349 -4.979146957397461 5.145845413208008 -4.979146957397461 7.100076198577881 L -4.979146957397461 14.56553649902344 L 0.1837937831878662 14.56553649902344 L 0.1837937831878662 6.543442726135254 C 0.1837937831878662 2.075184345245361 -2.358731746673584 3.814697265625e-06 -5.594671249389648 3.814697265625e-06">
					</path>
				</svg>
			</a>
				<svg class="Jrny_Jnks_linked_in_i_shadow_space_websi" viewBox="0.931 -22.783 4.553 14.427">
					<path id="Jrny_Jnks_linked_in_i_shadow_space_websi" d="M 0.9310000538825989 -8.35551643371582 L 5.484113693237305 -8.35551643371582 L 5.484113693237305 -22.78300476074219 L 0.9310000538825989 -22.78300476074219 L 0.9310000538825989 -8.35551643371582 Z">
					</path>
				</svg>
				<svg class="Jrny_Jnks_top_dot_i_shadow_space_website" viewBox="-4.392 0 5.527 5.006">
					<path id="Jrny_Jnks_top_dot_i_shadow_space_website" d="M -1.610737085342407 0 C -3.292033195495605 0 -4.392000198364258 1.079702377319336 -4.392000198364258 2.505163192749023 C -4.392000198364258 3.902759790420532 -3.323695659637451 5.005893707275391 -1.675329208374023 5.005893707275391 L -1.642399907112122 5.005893707275391 C 0.06929254531860352 5.005893707275391 1.135063052177429 3.898960590362549 1.135063052177429 2.50072979927063 C 1.10213315486908 1.077169299125671 0.06929254531860352 0 -1.610737085342407 0">
					</path>
				</svg>
			</div>
		</div>:""}
        {props.data.instagramUrl?	
		<div title="Instagram" id="Jrny_Jnks_Insta_grp_shadow_space_website">
			<svg class="Jrny_Jnks_shadow_space_website_7">
				<ellipse id="Jrny_Jnks_shadow_space_website_7" rx="24" ry="24" cx="24" cy="24">
				</ellipse>
			</svg>
			<a href={props.data.instagramUrl} target="_blank">
			<img id="Jrny_Jnks_instagramshadow_space_website_" src="./Themes/JourneyJunkies/instagramshadow_space_website_.png"  srcset="./Themes/JourneyJunkies/instagramshadow_space_website_.png 1x" />
				
			</a>
		</div>:""}
		{props.data.whatsAppNumber?
		<div title="WhatsApp" id="Jrny_Jnks_whatsapp_grp_shadow_space_webs">
			<svg class="Jrny_Jnks_med_shadow_space_website_7_ej">
				<ellipse id="Jrny_Jnks_med_shadow_space_website_7_ej" rx="24" ry="24" cx="24" cy="24">
				</ellipse>
			</svg>
            <a href={"https://api.whatsapp.com/send?phone="+props.data.whatsAppNumber.substring(props.data.whatsAppNumber.length-10)} target="_blank">
			<img id="Jrny_Jnks_whatsapp_lbl_shadow_space_webs" src="./Themes/JourneyJunkies/whatsapp_lbl_shadow_space_webs.png"  srcset="./Themes/JourneyJunkies/whatsapp_lbl_shadow_space_webs.png 1x" />
				</a>
		</div>:""}
	</div>
	<div id="Jrny_Jnks_Group_14873">
		<img id="Jrny_Jnks_kisspng-billboard-advertising-" src="./Themes/JourneyJunkies/kisspng-billboard-advertising-.png"  srcset="./Themes/JourneyJunkies/kisspng-billboard-advertising-.png 1x" />
			
		<iframe src={"https://maps.google.com/maps?width=100%25&height=600&hl=en&q="+((props.data.mapLatitude && (props.data.mapLatitude.toString()).length > 0)?props.data.mapLatitude.toString():"13.027696798394835")+","+((props.data.mapLongitude && (props.data.mapLongitude.toString()).length > 0)?props.data.mapLongitude.toString():"77.61844225211368")+"&t=&z=20&ie=UTF8&iwloc=B&output=embed&embedded=true;"} width="600" height="450" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" class="Jrny_Jnks_Rectangle_689">
			<rect id="Jrny_Jnks_Rectangle_689" rx="0" ry="0" x="0" y="0" width="617" height="286">
			</rect>
		</iframe>
	</div>
	<div id="Jrny_Jnks_n_234567890_mobile_number_shad">
		<span>{props.data.businessPhone}</span>
	</div>
	<div id="Jrny_Jnks_affanghanioperatelive_email_sh">
		<span>{props.data.businessEmail}</span>
	</div>
	<div id="Jrny_Jnks_address_med_shadow_space_websi">
		<span>{props.data.businessAddress}</span>
	</div>
	<img id="Jrny_Jnks_location_img_shadow_space_webs" src="./Themes/JourneyJunkies/location_img_shadow_space_webs.png"  srcset="./Themes/JourneyJunkies/location_img_shadow_space_webs.png 1x" />
		
	<img id="Jrny_Jnks_email_address_shadow_space_web" src="./Themes/JourneyJunkies/email_address_shadow_space_web.png"  srcset="./Themes/JourneyJunkies/email_address_shadow_space_web.png 1x" />
		
	<img id="Jrny_Jnks_phone_number_shadow_space_webs" src="./Themes/JourneyJunkies/phone_number_shadow_space_webs.png"  srcset="./Themes/JourneyJunkies/phone_number_shadow_space_webs.png 1x" />
		
	<div id="Jrny_Jnks_n_Copyright_Operate_Live_OPC_P">
		<span>© Copyright Operate Live (OPC) Private Limited. All Rights Reserved</span>
	</div>
</div>
  )
}

export default JourneyJunkies
